import { FormControl, TextInput } from 'glic-ui-components';
const Textbox = ({ value, onTextChange, Id, title, required, type, width, isDisabled, ariaLabelledby, labelName, ariDescBy }) => {
    return (
        <div >
            {required == true ?
                <FormControl
                    isDisabled={false}
                    validations={{
                        required: { message: `${labelName} field is required.`},
                    }}
                    validateOnChange
                    validateOnBlur
                >
                    <TextInput
                        id={Id}
                        name={Id}
                        label={title}
                        type={type}
                        onChange={onTextChange}
                        isDisabled={isDisabled}
                        value={value}
                        width={width}
                        aria-labelledby={ariaLabelledby}
                        aria-describedby={ariDescBy}
                    />
                </FormControl>
                :
                <TextInput
                    id={Id}
                    name={Id}
                    label={title}
                    type={type}
                    onChange={onTextChange}
                    isDisabled={isDisabled}
                    value={value}
                    width={width}
                />
            }
        </div>
    )
}

export default Textbox
